<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="标题">
                    <el-input v-model="query.keyword" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="query.question_type" placeholder="全部" clearable>
                        <el-option v-for="(item, index) in question_type_array" :label="item" :value="index" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/question/add'">添加题目</el-button>
            <el-button size="small" type="success" @click="import_true = true" icon="el-icon-upload2" v-auth="'/education/question/batchImport'">批量导入题目</el-button>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="question_id" label="题目ID" width="80"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <!--                    <el-table-column prop="category" label="所属分类" width="180">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                           {{scope.row.category ? scope.row.category.name : ''}}-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column prop="question_type_desc" label="类型" width="200"></el-table-column>
                    <el-table-column prop="status_desc" label="状态" width="100"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="140">
                        <template slot-scope="scope">
                            <el-button @click="handleDetail(scope.row)" type="text" size="small" v-auth="'/education/question/detail'">详情</el-button>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/question/edit'">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/question/del'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
        <edit ref="edit" @fetch-data="refresh"></edit>
        <detail ref="detail" />

        <el-dialog title="批量导入说明" :visible.sync="import_true" width="30%">
            <div>1、只能导入 判断题 选择题 多选题</div>
            <div>2、每次导入题目数量不超过1000, 超过的自己手动拆分为多个表格依次导入</div>
            <div>3、重复的题目不会覆盖写入</div>
            <div>4、请严格按照模板填写，<el-link type="primary" :underline="false" href="/question_import.xlsx">下载模板</el-link>
            </div>
            <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
                <el-upload class="avatar-uploader" ref="upload" action="string"
                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :auto-upload="true"
                           :before-upload="onBeforeUploadImage" :http-request="UploadImage" :show-file-list="false">
                    <el-button size="small" icon="el-icon-upload" type="primary">上传题目表格</el-button>
                </el-upload>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {questionList, questionDel, batchImport} from '@/api/education';
    import Edit from './edit.vue';
    import Detail from './detail';

    export default {
        components: {
            /*编辑组件*/
            Edit,
            Detail,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                query: {
                    question_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                question_type_array: [],
                import_true: false
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                questionList(this.query).then((result)=>{
                    this.loading = false
                    this.question_type_array = result.data.question_type
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            handleDetail(row){
                this.$refs['detail'].showDialog(row)
            },
            // 添加
            handleAdd(){
                this.$refs['edit'].showDialog()
            },
            // 编辑
            handleEdit(row) {
                this.$refs['edit'].showDialog(row)
            },
            // 删除
            handleDelete(row) {
                if (row.question_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        questionDel({ids: row.question_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.question_type = val
            },

            /*选择图片之前*/
            onBeforeUploadImage(file) {
                var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
                const isEXCEL = fileType === 'xlsx';
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isEXCEL) {
                    this.$message.error('上传文件只能是excel格式!');
                }
                if (!isLt10M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                }
                return isEXCEL && isLt10M;
            },
            /*上传图片*/
            UploadImage(param) {
                let self = this;
                const loading = this.$loading({
                    lock: true,
                    text: '正在处理,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = new FormData();
                formData.append('iFile', param.file);
                batchImport(formData).then(response => {
                        loading.close();
                        self.import_true = false;
                        self.$message({message: response.msg, type: 'success'});
                        this.refresh()
                    }).catch(response => {
                        loading.close();
                        self.$message({message: '本次处理失败', type: 'warning'});
                        param.onError();
                    });
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/question/index.vue